import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Sidebar() {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [hovered, setHovered] = useState(false);

  const menuItems = [
    {
      to: "/admin",
      label: "لوحة التحكم",
      icon: "📊",
      end: true,
    },
    {
      label: "المحتوى",
      icon: "📁",
      submenu: [
        { to: "/admin/academies", label: "الأكاديميات" },
        { to: "/admin/plans", label: "الخطط" },
        { to: "/admin/faqs", label: "الأسئلة الشائعة" },
        { to: "/admin/testimonials", label: "الشهادات" },
        { to: "/admin/contacts", label: "روابط التواصل" },
      ],
    },
    {
      to: "/admin/ai-features",
      label: "ميزات الذكاء الاصطناعي",
      icon: "🤖",
      badge: "NEW",
    },
    {
      label: "المستخدمين",
      icon: "👥",
      submenu: [
        { to: "/admin/users", label: "قائمة المستخدمين" },
        { to: "/admin/users/new", label: "إضافة مستخدم" },
        { to: "/admin/roles", label: "الأدوار والصلاحيات" },
      ],
    },
    {
      label: "الإعدادات",
      icon: "⚙️",
      submenu: [
        { to: "/admin/settings/general", label: "عام" },
        { to: "/admin/settings/security", label: "الأمان" },
        { to: "/admin/settings/notifications", label: "الإشعارات" },
        { to: "/admin/settings/backup", label: "النسخ الاحتياطي" },
      ],
    },
    {
      to: "/admin/analytics",
      label: "التقارير والإحصائيات",
      icon: "📈",
    },
    {
      to: "/admin/help",
      label: "المساعدة والدعم",
      icon: "❓",
    },
  ];

  const toggleSubmenu = (label) => {
    if (activeSubmenu === label) {
      setActiveSubmenu(null);
    } else {
      setActiveSubmenu(label);
    }
  };

  const isSubmenuActive = (submenuItems) => {
    return submenuItems?.some(item => 
      window.location.pathname.startsWith(item.to)
    );
  };

  useEffect(() => {
    // توسيع القائمة الفرعية النشطة بناءً على المسار الحالي
    menuItems.forEach(item => {
      if (item.submenu && isSubmenuActive(item.submenu)) {
        setActiveSubmenu(item.label);
      }
    });
  }, []);

  const sidebarWidth = collapsed ? 80 : 260;
  const isExpanded = collapsed && hovered;

  return (
    <aside 
      className={`sidebar ${collapsed ? "collapsed" : ""} ${isExpanded ? "expanded" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* زر تصغير/تكبير الشريط الجانبي */}
      <div className="sidebar-header">
        {!collapsed && (
          <h3 className="sidebar-title">القائمة الجانبية</h3>
        )}
        <button 
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "توسيع القائمة" : "تصغير القائمة"}
        >
          {collapsed ? "→" : "←"}
        </button>
      </div>

      {/* قائمة التنقل */}
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => {
            const isActive = item.to && window.location.pathname === item.to;
            const hasActiveSubmenu = isSubmenuActive(item.submenu);
            
            return (
              <li 
                key={item.label} 
                className={`nav-item ${item.submenu ? "has-submenu" : ""} ${
                  isActive || (item.submenu && activeSubmenu === item.label) ? "active" : ""
                }`}
              >
                {item.submenu ? (
                  <>
                    <button
                      className="nav-link submenu-toggle"
                      onClick={() => toggleSubmenu(item.label)}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      {(!collapsed || isExpanded) && (
                        <>
                          <span className="nav-label">{item.label}</span>
                          <span className={`submenu-arrow ${
                            activeSubmenu === item.label ? "open" : ""
                          }`}>
                            ▼
                          </span>
                        </>
                      )}
                      {item.badge && (!collapsed || isExpanded) && (
                        <span className="nav-badge">{item.badge}</span>
                      )}
                    </button>
                    
                    {/* القائمة الفرعية */}
                    <div 
                      className={`submenu ${
                        (activeSubmenu === item.label || hasActiveSubmenu) ? "open" : ""
                      }`}
                      style={{
                        maxHeight: (activeSubmenu === item.label || hasActiveSubmenu) 
                          ? `${item.submenu.length * 45}px` 
                          : "0px"
                      }}
                    >
                      {item.submenu.map((subItem) => (
                        <NavLink
                          key={subItem.to}
                          to={subItem.to}
                          className={({ isActive }) => 
                            `submenu-link ${isActive ? "active" : ""}`
                          }
                          end={subItem.end}
                        >
                          {(!collapsed || isExpanded) && subItem.label}
                        </NavLink>
                      ))}
                    </div>
                  </>
                ) : (
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) => 
                      `nav-link ${isActive ? "active" : ""}`
                    }
                  >
                    <span className="nav-icon">{item.icon}</span>
                    {(!collapsed || isExpanded) && (
                      <>
                        <span className="nav-label">{item.label}</span>
                        {item.badge && (
                          <span className="nav-badge">{item.badge}</span>
                        )}
                      </>
                    )}
                  </NavLink>
                )}
              </li>
            );
          })}
        </ul>
      </nav>

      {/* الجزء السفلي من الشريط الجانبي */}
      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">أ</div>
          {(!collapsed || isExpanded) && (
            <div className="user-details">
              <span className="user-name">أحمد محمد</span>
              <span className="user-role">مدير النظام</span>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .sidebar {
          width: 260px;
          height: 100vh;
          background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
          color: white;
          display: flex;
          flex-direction: column;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: fixed;
          top: 70px;
          right: 0;
          z-index: 100;
          overflow-y: auto;
          overflow-x: hidden;
          scrollbar-width: thin;
          scrollbar-color: #475569 transparent;
        }

        .sidebar.collapsed {
          width: 80px;
        }

        .sidebar.collapsed.expanded {
          width: 260px;
          box-shadow: 5px 0 20px rgba(0, 0, 0, 0.3);
        }

        .sidebar::-webkit-scrollbar {
          width: 6px;
        }

        .sidebar::-webkit-scrollbar-track {
          background: transparent;
        }

        .sidebar::-webkit-scrollbar-thumb {
          background: #475569;
          border-radius: 3px;
        }

        .sidebar-header {
          padding: 20px;
          border-bottom: 1px solid #334155;
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 60px;
        }

        .sidebar-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #f8fafc;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .collapse-btn {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: white;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 14px;
        }

        .collapse-btn:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: rotate(180deg);
        }

        .sidebar-nav {
          flex: 1;
          padding: 16px 12px;
        }

        .nav-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .nav-item {
          position: relative;
        }

        .nav-item.active::before {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 20px;
          background: #3b82f6;
          border-radius: 0 4px 4px 0;
        }

        .nav-link {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 16px;
          color: #cbd5e1;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
          cursor: pointer;
          width: 100%;
          text-align: right;
          background: none;
          border: none;
          font-family: inherit;
          font-size: 14px;
          position: relative;
        }

        .nav-link:hover {
          background: rgba(255, 255, 255, 0.05);
          color: white;
        }

        .nav-link.active {
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
          font-weight: 500;
        }

        .nav-icon {
          font-size: 20px;
          width: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .nav-label {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .nav-badge {
          background: #ef4444;
          color: white;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 10px;
          font-weight: 600;
        }

        .submenu-toggle {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .submenu-arrow {
          font-size: 10px;
          transition: transform 0.3s ease;
          transform: rotate(-90deg);
        }

        .submenu-arrow.open {
          transform: rotate(0deg);
        }

        .submenu {
          overflow: hidden;
          transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          margin-right: 32px;
          border-right: 1px solid rgba(255, 255, 255, 0.1);
        }

        .submenu-link {
          display: block;
          padding: 10px 16px;
          color: #94a3b8;
          text-decoration: none;
          border-radius: 6px;
          margin: 2px 0;
          font-size: 13px;
          transition: all 0.3s ease;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .submenu-link:hover {
          background: rgba(255, 255, 255, 0.03);
          color: #e2e8f0;
        }

        .submenu-link.active {
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
          font-weight: 500;
        }

        .sidebar-footer {
          padding: 20px;
          border-top: 1px solid #334155;
          background: rgba(0, 0, 0, 0.2);
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #8b5cf6, #6366f1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 16px;
          flex-shrink: 0;
        }

        .user-details {
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .user-name {
          font-size: 14px;
          font-weight: 500;
          color: #f8fafc;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .user-role {
          font-size: 12px;
          color: #94a3b8;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .sidebar {
            width: 100%;
            max-width: 280px;
            transform: translateX(100%);
            transition: transform 0.3s ease;
            top: 60px;
          }

          .sidebar.collapsed {
            transform: translateX(100%);
          }

          .sidebar.collapsed.expanded {
            transform: translateX(0);
          }

          .collapse-btn {
            display: none;
          }
        }

        /* أنماط خاصة للوضع المصغر */
        .sidebar.collapsed:not(.expanded) {
          .nav-label,
          .sidebar-title,
          .user-details,
          .submenu-arrow,
          .nav-badge,
          .submenu {
            display: none;
          }

          .nav-link {
            justify-content: center;
            padding: 16px;
          }

          .nav-icon {
            font-size: 22px;
          }

          .user-info {
            justify-content: center;
          }
        }

        /* تحسينات للشاشات الكبيرة */
        @media (min-height: 800px) {
          .sidebar {
            height: calc(100vh - 70px);
          }
        }
      `}</style>
    </aside>
  );
}